<template>
  <v-navigation-drawer
    v-if="shouldShowHelpDrawer"
    v-model="drawerModel"
    disable-resize-watcher
    right
    app
    clipped
    temporary
    dark
    color="secondary"
    width="400"
    class="help-drawer"
  >
    <div class="help-drawer__inner">
      <header class="help-drawer__header">
        <v-list class="py-0">
          <v-list-item class="px-2 ma-0">
            <v-list-item-title class="font-weight-bold subtitle-1 d-flex align-center">
              <v-icon class="mr-2" small>mdi-help-circle</v-icon>
              <span>Help</span>
            </v-list-item-title>
            <v-btn icon aria-label="Close help" @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
        <v-divider />
      </header>

      <div class="help-drawer__content">
        <v-btn
          href="https://docs.tendertrace.com/guide"
          target="_blank"
          text
          small
          color="white"
          class="text-capitalize body-2 help-drawer__link"
        >
          User Guide
          <v-icon medium right>mdi-file-document</v-icon>
        </v-btn>

        <v-btn
          text
          small
          color="white"
          class="text-capitalize body-2 help-drawer__link"
          @click="sendSupportMsg"
        >
          Contact Support
          <v-icon medium right>mdi-headset</v-icon>
        </v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "HelpDrawer",

  props: {
    shouldShowHelpDrawer: {
      type: Boolean,
      default: false,
    },
    rightDrawerOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    drawerModel: {
      get() {
        return this.isOpen;
      },
      set(next) {
        if (!next) {
          this.close();
          return;
        }
        this.open();
      },
    },
  },

  watch: {
    rightDrawerOpen(isOpen) {
      if (isOpen) {
        this.close();
      }
    },
  },

  methods: {
    open() {
      this.isOpen = true;
      this.$emit("close-utility-drawers");
    },

    close() {
      this.isOpen = false;
    },

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    sendSupportMsg() {
      const currentURL = window.location.href;

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          Authorization: "pk_vU6EIAOfRouzmn3x",
        },
        body: JSON.stringify({
          allowDuplicates: false,
          domain: "go.tendertrace.com",
          originalURL: currentURL,
        }),
      };

      fetch("https://api.short.io/links/public", options)
        .then((response) => response.json())
        .then((response) => {
          window.location.href =
            "mailto:" +
            "support@tendertrace.com?subject=Tendertrace Support Query&body=Source page: " +
            response.shortURL +
            "%0D" +
            "%0DPlease enter your message below this line.%0D";
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
/*
 * Vuetify 2 only applies clipped top offset when the drawer is not temporary
 * (hasApp is false for temporary drawers). Position below the app header.
 */
.help-drawer.v-navigation-drawer--fixed {
  top: var(--app-header-height, 64px) !important;
  height: calc(100% - var(--app-header-height, 64px)) !important;
  max-height: calc(100% - var(--app-header-height, 64px)) !important;
}

.help-drawer >>> .v-navigation-drawer__content {
  height: 100%;
  overflow: hidden;
}

.help-drawer__inner {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.help-drawer__header {
  flex-shrink: 0;
}

.help-drawer__content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 4px;
}

.help-drawer__link {
  display: flex;
  justify-content: flex-start;
}
</style>
